import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

const SkeletonTable = ({ rows = 6, columns = 5, withPhoto = false }) => (
  <table className="skeleton-table" aria-busy="true" aria-live="polite">
    <tbody>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr key={rowIndex}>
          {withPhoto && (
            <td>
              <SkeletonBone className="skeleton-table__thumb" />
            </td>
          )}
          {Array.from({ length: columns }, (_, colIndex) => (
            <td key={colIndex}>
              <SkeletonBone
                className="skeleton-table__cell"
                style={{ width: `${55 + ((rowIndex + colIndex) % 4) * 10}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export default SkeletonTable;
